<template>
   <div>
      <br><br>
      <footer style="background-color: #e9ecef; padding: 8px 20px">
         <div class="pull-right">
            Copyright &copy; 2019 - {{(new Date()).getFullYear()}} | Powered by {{panelData.com_name}}. <span class="glyphicon glyphicon-info-sign" data-toggle="modal" data-target="#myModal"></span> <b>V2.0</b>
         </div>
         <div class="clearfix"></div>
      </footer>
   </div>
</template>
<script>
   import {mapGetters} from 'vuex'
   export default {
     name: "AppFooter",
     computed: {
       ...mapGetters({
         panelData : 'getPanelData'
       })
     },
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>